//
// Component: Hand
//
// Displays and controls a player's hand
//

// dependencies
import React from 'react'
import { Box, Flex } from 'rebass'
import { observer, toJS } from 'mobx-react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import GameStore from 'App/stores/GameStore'

import Card from 'App/components/card/Card.js'
import Game from '../../screens/Game'


@observer
class Hand extends React.Component {
  //
  // props
  //
  // active - north, south, east, west - the hand that is in play
  // displayAsFan - true/false - display hand in fan style
  // dummy - true/false - your partner
  // hand - cards in PBN format
  // horizontalCards - true/false - orientation of cards
  // horizontalHand - true/false - orientation of hand
  // player - north, south, east, west - this player
  // showMarker - true/false - not sure what this is yet
  // visible - true/false - if false the back of the card will be shown
  // spacing - passed through to Card to define spacing between cards
  //           this will be different for a full hand and just one suit
  // showCloseMarker - true/false - whether to show the 'clsoe' button
  //                   if a single suit is shown

  constructor (props) {
    super(props)
    this.state = {
      singleSuitMode: false,
      spacing: 0.25,
      observer: false,
      sessionStatus: {},
      cards: '',
      dummy: false,
      active: false,
      visible: true,
      showMarker: false,
      displayAsFan: false,
      horizontalHand: false,
      horizontalCards: false
    }

    // this.cardClicked = this.cardClicked.bind(this) // called after rendered so need to bind it to this component
    this.showAllCards = this.showAllCards.bind(this)
  }


  componentDidMount () {
    this.setState({
      displayCardHorizontal: this.isCardHorizontal(),
      displayHandHorizontal: this.isHandHorizontal(),
      isNorthorSouth: this.isPlayerNorthorSouth(),
    })
  }


  showAllCards () {
    this.props.clickCloseMarker(this.props.player)
  }

  isCardHorizontal () {
    if ((this.props.player === 'east' || this.props.player === 'west') && !this.props.dummy) {
      return true
    } else {
      return false
    }
  }

  isPlayerNorthorSouth () {
    if (this.props.player === 'north' || this.props.player === 'south') {
      return true
    } else {
      return false
    }
  }

  isHandHorizontal () {
    if ((this.props.player === 'north' || this.props.player === 'south')) {
      return true
    } else {
      return false
    }
  }
  //
  // FUNCTION: renderHand
  //
  // Builds a Hand of Card components
  // Note that this function has been partially copied
  // from the BridgeJS library
  //
  // INPUT: pbn - a hand in PBN notation
  //

  render () {
    const player = this.props.player
    const playerHand = this.props.playerHandData
    let renderedSuits = []
    for (const suit of playerHand.suitOrder) {
      let suitKey = suit.charAt(0).toUpperCase()

      let renderedCards = []

      for (const card of playerHand[suit]) {
        renderedCards.push(
          <Card
            id={this.props.player + card}
            key={this.props.player + card}
            spacing={this.state.spacing}
            hand={this.props.player}
            dummy={playerHand.isDummy}
            suit={suitKey}
            rank={card}
            visible={playerHand.cardsVisible}
            horizontalCard={playerHand.horizontalCard}
            horizontalHand={playerHand.horizontalHand}
            cardClicked={this.props.cardClicked}
            currentPlayer={this.props.currentPlayer}
          />
        )
      }
      renderedSuits.push(
        <Box className={`suit suit-${suit}`}>
          {renderedCards}
        </Box>
      )
    }

    let handClasses = `hand hand-player-${player}`
    handClasses += ` hand-dummy-${playerHand.isDummy ? 'yes' : 'no'}`
    if (playerHand.showSingleSuit) handClasses += ` hand-singlesuit hand-singlesuit-${playerHand.showSingleSuit}`
    handClasses += ` hand-active-${playerHand.isActive ? 'yes' : 'no'}`

    return (
      <Box className={handClasses}>
        {renderedSuits}
        {playerHand.showSingleSuit &&
          <Box
            sx={{
              padding: 2,
              bg: '#492a2c',
              margin: 2,
              position: 'absolute',
              top: 0,
              right: '-30px',
              cursor: 'pointer'
            }}
            // eslint-disable-next-line react/jsx-handler-names
            onClick={this.showAllCards}
          >
            {/* eslint-disable-next-line react/jsx-handler-names */}
            <FontAwesomeIcon color='#fff' icon={['fas', 'times-circle']} />
          </Box>}
      </Box>
    )
  }
}
export default Hand
